(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangeFieldDialogController', ChangeFieldDialogController);

    ChangeFieldDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ChangeField'];

    function ChangeFieldDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ChangeField) {
        var vm = this;
        vm.changeField = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:changeFieldUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.changeField.id !== null) {
                ChangeField.update(vm.changeField, onSaveSuccess, onSaveError);
            } else {
                ChangeField.save(vm.changeField, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
